/* eslint-disable
    func-names,
    max-len,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const moduleDeps = [require('data/collection/ledger').name];

const ledgerWithTransactionsCollectionDeps = ['LedgerCollection'];

const ledgerWithTransactionsCollection = function (LedgerCollection) {
  let LedgerWithTransactionsCollection;
  return (LedgerWithTransactionsCollection = class LedgerWithTransactionsCollection extends (
    LedgerCollection
  ) {
    $url() {
      return `${super.$url()}/has_transactions`;
    }
  });
};

ledgerWithTransactionsCollection.$inject = ledgerWithTransactionsCollectionDeps;

module.exports = angular
  .module('bench.data.collection.ledgerWithTransactions', moduleDeps)
  .factory('LedgerWithTransactionsCollection', ledgerWithTransactionsCollection);
